export class MEAPeriodEntity {
  public POPNUMCYC: string = '';
  public PKGPPCYC: string = '';
  public EXFLISTP: string = '';
  public CLAWBACK: string = '';
  public PRCDISC: string = '';
  public PRCCUT: string = '';
  public PRCCONFIDDISCCYC: string = '';
  // This one is for EC
  public EXCAP: string = '';
  public REIMBGROSSCYC: string = '';
  // This one is for FCPP
  public FCPPC: string = '';
  // This one is for UC
  public PSUALU: string = '';
  public PVA_V = [];
  public PVA_S = [];
}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/entities/mea-period-entity.ts